<div class="row mt-minus-50">
  <div class="col-12 mb-3" style="margin-top: -40px;">
    <div [innerHTML]="video_embed" class="video_wrapper"></div>
  </div>
  <div class="col-12 text-center">
    <p [innerHTML]="content?.body"></p>
  </div>
  <div class="col-12 text-center">
    <a href="/interaction/game/video" class="btn-secondary btn rounded-pill text-white" >
      <span *ngIf="localStorage.getItem('l') === 'it'">Continua</span>
      <span *ngIf="localStorage.getItem('l') === 'en'">Continue</span>
      <span *ngIf="localStorage.getItem('l') === 'fr'">Continue</span></a>
  </div>
</div>
